import "./InstructionItem.less"

import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Row } from "antd"
import { FC, useEffect, useState } from "react"

const { Paragraph } = WebsiteTypography

export type InstructionItemProps = {
  title: string
  imageSrc: string
  imageAlt?: string
  listItems: string[]
}

const InstructionItem: FC<InstructionItemProps> = ({ title, imageSrc, imageAlt = "", listItems }) => {
  const [isZoomed, setIsZoomed] = useState(false)

  useEffect(() => {
    if (isZoomed) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }, [isZoomed])

  const handleImageClick = () => setIsZoomed(!isZoomed)

  return (
    <Row wrap={false}>
      <div className={"instruction-item-wrapper"}>
        <Paragraph centered weight={"w700"} color={"black"} size={"sm"}>
          {title}
        </Paragraph>

        <div
          className={`instruction-image-wrapper ${isZoomed ? "zoomed" : ""}`}
          onClick={handleImageClick}
          style={{ cursor: "pointer" }}
        >
          <img src={imageSrc} alt={imageAlt} />
        </div>

        <ul className={"list-wrapper"}>
          {listItems.map((item, index) => (
            <li key={index}>
              <Paragraph color={"black"} size={"xs"}>
                {item}
              </Paragraph>
            </li>
          ))}
        </ul>
      </div>
    </Row>
  )
}

export default InstructionItem
